import { render } from "./ProducerOrderConfirmationReminderModal.vue?vue&type=template&id=79df2cd4"
import script from "./ProducerOrderConfirmationReminderModal.vue?vue&type=script&lang=js"
export * from "./ProducerOrderConfirmationReminderModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__